import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'huge-monorepo-teltonika-create-tag-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-create-tag-modal.component.html',
  styleUrl: './teltonika-create-tag-modal.component.scss',
})
export class TeltonikaCreateTagModalComponent {
  nameControl: FormControl = new FormControl('', [Validators.required]);
  name: string = '';
  description: string = '';
  emailsFormControl: FormArray<FormControl<string>> = new FormArray<FormControl<string>>([]);

  constructor(
    public dialogRef: MatDialogRef<TeltonikaCreateTagModalComponent>,
    private formBuilder: FormBuilder,
  ) { }

  isValid(): boolean {
    return this.nameControl.valid && this.emailsFormControl.valid;
  }

  closeDialog(save: boolean): void {
    if (!save) {
      this.dialogRef.close(false);
      return;
    }

    if (this.isValid() === false) {
      this.emailsFormControl.markAllAsTouched();
      this.nameControl.markAsTouched();
      return;
    }

    this.dialogRef.close({
      Name: this.name,
      Description: this.description,
      Emails: this.emailsFormControl.controls.map(control => control.value),
    });
  }

  addNewEmail(): void {
    this.emailsFormControl.push(this.formBuilder.nonNullable.control('', [Validators.email, Validators.required]));
  }
}
